__turbopack_context__.v({
  "actionButton": "Task-module__8_ik_G__actionButton",
  "statusIcon": "Task-module__8_ik_G__statusIcon",
  "taskContainer": "Task-module__8_ik_G__taskContainer",
  "taskContent": "Task-module__8_ik_G__taskContent",
  "taskText": "Task-module__8_ik_G__taskText",
});
